<template lang="pug">
  .cache-date(v-if='lastUpdated') Generated on {{ lastUpdated }}
</template>

<script>

import { DateTime } from 'luxon';

export default {
  name: 'ReportDetails',
  props: {
    data: Object
  },
  computed: {
    lastUpdated: function () {
      return this.data.lastUpdated ? DateTime.fromISO(this.data.lastUpdated).toFormat('DD, t') : null;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
</style>
